/**
 * Created by PhpStorm on 07.06.2017.
 * Author: Shabalin Pavel
 * Email: aisamiery@gmail.com
 */
'use strict';

angular.module('far.admin')
    .controller('MenuController', function (form, $rootScope, MenuItem) {
        var vm = {
            form: {},
            formEdit: form("form"),
            progress: false,
            constructor: function (menuitem) {
                vm.progress = !!menuitem;
                vm.form = MenuItem.get(menuitem, function() {
                    vm.progress = false;
                });
            },
            submit: function() {
                vm.form.save()
                    .then(function (response) {
                        vm.progress = true;
                        window.location.href = '/admin/menu/' + response.data.id;
                    }, function errorCallback(response) {
                        response = http.authenticationListener(response);
                        vm.errors = [];

                        if (angular.isDefined(response.data.errors) ) {
                            for ( var key in response.data.errors ) {
                                vm.errors.push(response.data.errors[key]);
                            }
                        } else {
                            showModalMessage('Ошибка на сервере. Попробуйте позже.');
                        }

                        vm.submitted = false;
                        vm.progress = false;
                    })
            },
            delete: function(id) {
                if (!window.confirm('Удалить пункт меню?')) {
                    return;
                }
                vm.progress = true;
                MenuItem.delete({id: id})
                    .then(function (response) {
                        vm.progress = false;
                        location.reload();
                    });
            }
        };

        vm.formEdit
            .addField('name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Название',
                    class: 'form__item'
                }
            })
            .addField('url', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Ссылка',
                    class: 'form__item'
                }
            })
            .addField('title', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Титл ссылки',
                    class: 'form__item'
                }
            })
            .addField('sort', 'number', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Сортировка',
                    class: 'form__item',
                }
            })
            .addField('parent', 'selectObject', {
                validators: {
                    required: false
                },
                defaultOption: 'Родитель',
                ngOptions: 'item as item.name disable when item.disable for item in field.items track by item.id',
                label: 'Родительская страница'
            }, MenuItem.list)
        ;


        return vm;
    });
